import { IResponse } from "models";

export enum ActionType {
  HOLIDAY_LIST = "action/HOLIDAY_LIST",
  HOLIDAY_LIST_SUCCESS = "action/HOLIDAY_LIST_SUCCESS",
  HOLIDAY_LIST_ERROR = "action/HOLIDAY_LIST_ERROR",
  HOLIDAY_LIST_RESET = "action/HOLIDAY_LIST_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IGetHolidayPayload {
  from_date: string;
  to_date: string;
}

export interface IHolidayItem {
  id: number;
  created_at: string;
  holiday_date: string;
  updated_at: string;
}

export interface IGetHolidayResponse extends IResponse {
  result: IHolidayItem[];
}
